import { render, staticRenderFns } from "./chair_jizhi.vue?vue&type=template&id=8e2e88a4&scoped=true&"
import script from "./chair_jizhi.vue?vue&type=script&lang=js&"
export * from "./chair_jizhi.vue?vue&type=script&lang=js&"
import style0 from "./chair_jizhi.vue?vue&type=style&index=0&id=8e2e88a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2e88a4",
  null
  
)

export default component.exports